export const PublicURL = {
    // Landing Pages
    HOME: '/',

    // Company Pages
    ABOUT_US: '/about-us',
    CAREERS: '/careers',
    CONTACT_US: '/contact',
    VISION: '/vision',

    // Workplace Pages
    ANALYTICS: '/analytics',
    AUTOMATION: '/automation',
    INTEGRATIONS: '/integrations',
    WORKFLOWS: '/workflows',

    // Legal Pages
    PRIVACY_POLICY: '/privacy-policy',
    TERMS_AND_CONDITIONS: '/terms-and-conditions',

    // Document Upload Pages
    UPLOAD_REQUESTED_DOCUMENT: '/upload-document/:token',
    upload_requested_document: (token) => `/upload-document/${token}`,
}
